import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../../components/global/Button';
import PhotosStep from './components/PhotosStep';
import SlidesStep from './components/SlidesStep';
import {
  ALBUM_PHOTO_FILTERS,
  ALBUM_SLIDESHOW_MODE,
} from '../../../../../../../../constants/albums';

const propTypes = {
  visible: PropTypes.bool,
  albumId: PropTypes.string.isRequired,
  saving: PropTypes.bool,
  slideshow: PropTypes.shape({
    mode: PropTypes.oneOf(Object.values(ALBUM_SLIDESHOW_MODE)),
  }).isRequired,
  slideshowSlides: PropTypes.array.isRequired,
  slidesTotal: PropTypes.number.isRequired,
  slidesOffset: PropTypes.number.isRequired,
  currentSlideId: PropTypes.string.isRequired,
  hasIntroSlide: PropTypes.bool.isRequired,
  onIntroSlideCreate: PropTypes.func.isRequired,
  onSlideshowUpdate: PropTypes.func.isRequired,
  loadingMore: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onDeletePhoto: PropTypes.func.isRequired,
  onMoveSlide: PropTypes.func.isRequired,
  onReorderSlides: PropTypes.func.isRequired,
  onDeleteLayout: PropTypes.func.isRequired,
  onThumbnailClick: PropTypes.func.isRequired,
  defaultAlbumPhotoFilter: PropTypes.oneOf(Object.values(ALBUM_PHOTO_FILTERS)),
};

const STEPS = {
  PHOTOS: 'PHOTOS',
  SLIDES: 'SLIDES',
};

const SecondaryPhotosView = ({
  visible,
  albumId,
  saving,
  slideshow,
  slideshowSlides,
  slidesTotal,
  slidesOffset,
  currentSlideId,
  hasIntroSlide,
  onIntroSlideCreate,
  onSlideshowUpdate,
  loadingMore,
  onLoadMore,
  onDeletePhoto,
  onMoveSlide,
  onReorderSlides,
  onDeleteLayout,
  onThumbnailClick,
  defaultAlbumPhotoFilter,
}) => {
  const [step, setStep] = useState(STEPS.SLIDES);

  useEffect(() => {
    if (defaultAlbumPhotoFilter) {
      setStep(STEPS.PHOTOS);
    }
  }, [defaultAlbumPhotoFilter]);

  if (!visible) {
    return null;
  }

  return (
    <Fragment>
      <div className="secondary-photos-view-container">
        <div className="secondary-photos-view-header">
          <Button
            btnStyle="reset"
            className={step === STEPS.SLIDES ? 'selected' : ''}
            onClick={() => setStep(STEPS.SLIDES)}
          >
            Slides
          </Button>
          <Button
            btnStyle="reset"
            className={step === STEPS.PHOTOS ? 'selected' : ''}
            onClick={() => setStep(STEPS.PHOTOS)}
          >
            Photos
          </Button>
        </div>
        {step === STEPS.SLIDES && (
          <SlidesStep
            saving={saving}
            slideshow={slideshow}
            slideshowSlides={slideshowSlides}
            slidesTotal={slidesTotal}
            slidesOffset={slidesOffset}
            currentSlideId={currentSlideId}
            hasIntroSlide={hasIntroSlide}
            onIntroSlideCreate={onIntroSlideCreate}
            onSlideshowUpdate={onSlideshowUpdate}
            loadingMore={loadingMore}
            onLoadMore={onLoadMore}
            onDeletePhoto={onDeletePhoto}
            onMoveSlide={onMoveSlide}
            onReorderSlides={onReorderSlides}
            onDeleteLayout={onDeleteLayout}
            onThumbnailClick={onThumbnailClick}
          />
        )}
        {step === STEPS.PHOTOS && (
          <PhotosStep
            albumId={albumId}
            defaultAlbumPhotoFilter={defaultAlbumPhotoFilter}
          />
        )}
      </div>
    </Fragment>
  );
};

SecondaryPhotosView.propTypes = propTypes;

export default SecondaryPhotosView;
